export const leSpecificHolidayTypes = [
  {
    leName: 'Limited Time LUX Exclusive',
    whiteLabelName: 'Limited Time Exclusive',
  },
]
